import { SharedModule } from './../../shared/shared.module'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { LoginComponent } from './login/login.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { authRoutes } from '../../containers/auth/auth.routing'
import { RequestPasswordResetComponent } from './request-password-reset/request-password-reset.component'
import { PasswordResetComponent } from './password-reset/password-reset.component'

@NgModule({
  declarations: [
    LoginComponent,
    RequestPasswordResetComponent,
    PasswordResetComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(authRoutes, { scrollPositionRestoration: 'top' }),
    HttpClientModule,
    SharedModule,
  ],
  exports: [LoginComponent],
})
export class AuthModule {}
